import HocSinhProfile from "./HocSinhProfile";
export default HocSinhProfile